import type { BuildFeeViewModel } from "@lumora/core";
import { useViewModel } from "@lumora/ui";

export interface BuildFeeSectionProps {
  viewModel: BuildFeeViewModel;
}

/**
 * BuildFeeSection triggers the one-off build-fee invoice and links the returned
 * hosted Stripe invoice. Hidden when this tenant has no quoted amount.
 */
export function BuildFeeSection({ viewModel }: BuildFeeSectionProps) {
  const state = useViewModel(viewModel);
  if (!viewModel.hasQuotedFee) {
    return null;
  }

  return (
    <section className="portal-section" data-lumora-view="build-fee">
      <h2>Build fee</h2>
      <p>
        One-time website build fee:{" "}
        <strong data-lumora-build-fee-amount>{viewModel.formattedAmount}</strong>.
      </p>

      {state.error ? (
        <p data-lumora-error className="portal-error">
          {state.error}
        </p>
      ) : null}

      {state.invoiceUrl ? (
        <p className="portal-notice">
          Invoice created ({state.status}).{" "}
          <a href={state.invoiceUrl} data-lumora-invoice-link target="_blank" rel="noreferrer">
            View &amp; pay invoice
          </a>
        </p>
      ) : (
        <button
          type="button"
          className="portal-btn"
          disabled={state.loading}
          onClick={() => void viewModel.create()}
        >
          {state.loading ? "Creating invoice…" : `Pay build fee (${viewModel.formattedAmount})`}
        </button>
      )}
    </section>
  );
}
